export default __webpack_public_path__ + "static/media/toki.ea1eed52.png";